import React, { useContext, useEffect, useState } from "react";
import BuyAndSell from "../../Components/Home/BuyAndSell/BuyAndSell";
import Footer from "../../parts/Footer/Footer";
import LottieContent from "../../Components/Home/LottieContent/LottieContent";
import NavbarContainer from "../../parts/Navbar/NavbarContainer";
import NewsFeed from "../../Components/Home/NewsFeed/NewsFeed";
import ServicesBar from "../../Components/Home/Services/ServicesBar";
import "./HomePage.css";
import MobileAbout from "../../parts/DropDown/MobileAbout/MobileAbout";
import { HamburgerContext } from "../../context/HamburgerContextProvider";
import { DownloadContext } from "../../context/DownloadContextProvider";
import LottieLoaderanim from "../../Uis/LottieLoader/LottieLoaderanim";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";
function HomePage() {
  const { showMediaIcons, handleFalse } = useContext(HamburgerContext);
  const { isFastTagLoading } = useContext(DownloadContext);
  const carCleanLocation = useLocation();
  const [carCleanActiveClass, setCarCleanActiveClass] = useState("");
  const hideHamburger = () => {
    handleFalse();
  };

  // car clean navbar change code



  useEffect(() => {
    if (carCleanLocation.pathname === "/car-clean") {
      setCarCleanActiveClass("carCleanActive");
    } else {
      setCarCleanActiveClass("");
    }
  }, [carCleanLocation]);

  return (
    <>
      <Helmet>
        <link rel="canonical" href="https://www.driveu.in/" />
        <meta charSet="utf-8" />
        <title>No. 1 Driver Service: Hire Professional Drivers Online</title>
        <meta
          name="description"
          content="Book professional car drivers for local and outstation trips, doorstep car wash, and other on-demand car services for a safe and convenient experience."
        />
        <meta
          name="keywords"
          content="car drivers in Ahmedabad, Bangalore, Chennai, Delhi NCR, Hyderabad, Kolkata, Mumbai &amp; Pune, Ahmedabad, Bangalore, Chennai, Delhi NCR, Hyderabad, Kolkata, Mumbai &amp; Pune car driver services, car drivers in Ahmedabad, Bangalore, Chennai, Delhi NCR, Hyderabad, Kolkata, Mumbai &amp; Pune for hire, car driver services in Ahmedabad, Bangalore, Chennai, Delhi NCR, Hyderabad, Kolkata, Mumbai &amp; Pune, car drivers for hire in Ahmedabad, Bangalore, Chennai, Delhi NCR, Hyderabad, Kolkata, Mumbai &amp; Pune, car drivers for rent in Ahmedabad, Bangalore, Chennai, Delhi NCR, Hyderabad, Kolkata, Mumbai &amp; Pune, car driver service in Ahmedabad, Bangalore, Chennai, Delhi NCR, Hyderabad, Kolkata, Mumbai &amp; Pune, car driver for hire in Ahmedabad, Bangalore, Chennai, Delhi NCR, Hyderabad, Kolkata, Mumbai &amp; Pune, car driver agency Ahmedabad, Bangalore, Chennai, Delhi NCR, Hyderabad, Kolkata, Mumbai &amp; Pune, car drivers in Ahmedabad, Bangalore, Chennai, Delhi NCR, Hyderabad, Kolkata, Mumbai &amp; Pune for rent, driver agency in Ahmedabad, Bangalore, Chennai, Delhi NCR, Hyderabad, Kolkata, Mumbai &amp; Pune, car driver service Ahmedabad, Bangalore, Chennai, Delhi NCR, Hyderabad, Kolkata, Mumbai &amp; Pune, Ahmedabad, Bangalore, Chennai, Delhi NCR, Hyderabad, Kolkata, Mumbai &amp; Pune car drivers services, hire a car driver in Ahmedabad, Bangalore, Chennai, Delhi NCR, Hyderabad, Kolkata, Mumbai &amp; Pune, hire car drivers in Ahmedabad, Bangalore, Chennai, Delhi NCR, Hyderabad, Kolkata, Mumbai &amp; Pune, book car drivers in Ahmedabad, Bangalore, Chennai, Delhi NCR, Hyderabad, Kolkata, Mumbai &amp; Pune"
        />
      </Helmet>
      {isFastTagLoading ? (
        <LottieLoaderanim />
      ) : (
        <div>
          <NavbarContainer activeClass = {carCleanActiveClass} />
          <div
            style={{ display: showMediaIcons ? "" : "none" }}
            className="MobileView_Option"
          >
            <MobileAbout />
          </div>

          <div onClick={hideHamburger}>
            <LottieContent />
            <ServicesBar />
            <NewsFeed />
            <BuyAndSell />
            <Footer />
          </div>
        </div>
      )}
    </>
  );
}

export default HomePage;
